import { render, staticRenderFns } from "./physiologyJump.vue?vue&type=template&id=5e3a7502&"
import script from "./physiologyJump.js?vue&type=script&lang=js&"
export * from "./physiologyJump.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports